import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackClosedVersionsTray, useTrackOpenedVersionsTray } from "@air/analytics";
import { Stack, TriangleDown, TriangleUp } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { memo } from "react";
import { useSelector } from "react-redux";
import { usePrevious } from "__barrel_optimize__?names=usePrevious!=!react-use";
import { VERSION_SNIPPET_DROPDOWN_BUTTON } from "~/constants/testIDs";
import { centralizedClipVersionNumberSelector } from "~/store/centralizedClip/selectors";
export const ToggleVersionsPanelButton = /*#__PURE__*/ memo((param)=>{
    let { isVersionsOpen, setIsVersionsOpen } = param;
    const versionNumber = useSelector(centralizedClipVersionNumberSelector);
    // After uploading a new version, the version # gets set to null momentarily
    // this prevents that.
    const previousVersionNumber = usePrevious(versionNumber);
    const { trackOpenedVersionsTray } = useTrackOpenedVersionsTray();
    const { trackClosedVersionsTray } = useTrackClosedVersionsTray();
    return /*#__PURE__*/ _jsx(Button, {
        appearance: isVersionsOpen ? "outline" : "ghost",
        color: "grey",
        "data-testid": VERSION_SNIPPET_DROPDOWN_BUTTON,
        onClick: ()=>{
            setIsVersionsOpen(!isVersionsOpen);
            if (isVersionsOpen) {
                trackClosedVersionsTray();
            } else {
                trackOpenedVersionsTray();
            }
        },
        prefix: /*#__PURE__*/ _jsx(Stack, {
            className: "mr-2 size-4"
        }),
        suffix: isVersionsOpen ? /*#__PURE__*/ _jsx(TriangleDown, {
            className: "ml-2 size-3"
        }) : /*#__PURE__*/ _jsx(TriangleUp, {
            className: "ml-2 size-3"
        }),
        children: "V".concat(versionNumber || previousVersionNumber)
    });
});
ToggleVersionsPanelButton.displayName = "ToggleVersionsPanelButton";
